import type { TFunction } from "i18next";

/**
 * Resolve a label/description that may be a translation key.
 * If the value starts with "formFields." it will be passed through t(),
 * otherwise the original string is returned (backward compatibility).
 */
export const tField = (t: TFunction, value?: unknown): string => {
  if (value === undefined || value === null) return "";
  const str = String(value);
  if (str.startsWith("formFields.")) {
    return t(str);
  }
  return str;
};

export default tField;